@if (selectedPipeline()) {
  <mat-accordion multi>
    @for (survey of surveyMenuDataSignal(); track survey.pipelineSurveyId) {
      <mat-expansion-panel
        [expanded]="survey.accordionIsExanded"
        (afterExpand)="setPanelState(survey.pipelineSurveyId, true)"
        (afterCollapse)="setPanelState(survey.pipelineSurveyId, false)"
      >
        <mat-expansion-panel-header>
          <div class="accordion-header">
            <mat-panel-title>{{ survey.title }}</mat-panel-title>
            <p class="accordion-description">{{ survey.surveyYear }}-{{ survey.surveyIdent }}</p>
          </div>
        </mat-expansion-panel-header>
        @if (survey.totalEvents > 0) {
          <div class="accordion-content">
            <mat-checkbox
              [disabled]="surveyMenuLayerIsLoadingIndicator()"
              [checked]="survey.eventIsChecked"
              (change)="selectionChanged($event.checked, survey, LayersTypes.SURVEY_EVENT_DATA_LAYER)"
            >
              Event Data
            </mat-checkbox>
            <div class="square" [style.background-color]="survey.eventsColor"></div>
            @if (surveyMenuLayerIsLoadingIndicator()) {
              <mat-spinner diameter="25" class="loading-spinner" />
            }
            <button
              mat-icon-button
              (click)="exportGeoJson(survey, LayersTypes.SURVEY_EVENT_DATA_LAYER)"
              matTooltip="Download GeoJSON"
              [disabled]="!survey.eventIsChecked || surveyMenuLayerIsLoadingIndicator()"
            >
              <mat-icon>{{ fileDownloadIcon }}</mat-icon>
            </button>
          </div>
        }
        @if (survey.totalBathy > 0) {
          <div class="accordion-content">
            <mat-checkbox
              [disabled]="surveyMenuLayerIsLoadingIndicator()"
              [checked]="survey.bathyIsChecked"
              (change)="selectionChanged($event.checked, survey, LayersTypes.SURVEY_BATHY_DATA_LAYER)"
            >
              Bathymetric Data
            </mat-checkbox>
            <div class="square" [style.background-color]="survey.bathyColor"></div>
            @if (surveyMenuLayerIsLoadingIndicator()) {
              <mat-spinner diameter="25" class="loading-spinner" />
            }
            <button
              mat-icon-button
              (click)="exportGeoJson(survey, LayersTypes.SURVEY_BATHY_DATA_LAYER)"
              matTooltip="Download GeoJSON"
              [disabled]="!survey.bathyIsChecked || surveyMenuLayerIsLoadingIndicator()"
            >
              <mat-icon>{{ fileDownloadIcon }}</mat-icon>
            </button>
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
} @else {
  <p>Please select a pipeline.</p>
}
